export default __webpack_public_path__ + "static/media/fundo.6d681027.jpg";